export enum ListMode {
  None = 'None',
  SingleSelect = 'SingleSelect',
  SingleSelectBegin = 'SingleSelectBegin',
  SingleSelectEnd = 'SingleSelectEnd',
  MultiSelect = 'MultiSelect',
  Delete = 'Delete'
}
